import { FocusEvent, ReactNode } from 'react'

export interface WaiverFields {
  waiverEnabled?: boolean
  waiverText?: string
}

export interface WaiverSectionProps {
  waiver: WaiverFields
  setFieldValue: (field: string, value: unknown) => void
  setFieldTouched: (field: string, touched?: boolean) => void
  handleBlur: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  fieldNames?: {
    enabled?: string
    text?: string
  }
  errors?: Record<string, string | undefined>
  touched?: Record<string, boolean | undefined>
  checkboxLabel?: string
  checkboxHelperText?: string
  textLabel: string
  textDescription: string
  textPlaceholder: string
  /** When true, waiver text is read-only (e.g. consent already collected). Checkbox can still toggle enabled. */
  contentReadOnly?: boolean
  hideEnabledToggle?: boolean
  /** Optional content rendered directly under the checkbox, above the waiver text field. Only shown when the waiver is enabled. */
  enabledContent?: ReactNode
  /** When true, the checkbox is disabled and all interactive content (template picker, waiver text editor) is hidden. */
  readOnly?: boolean
  /** Tooltip text shown when readOnly is true. */
  readOnlyTooltip?: string
}
